import { CREATE_USER_APPOINTMENT, EDIT_USER_APPOINTMENT, USER_APPOINTMENT_LIST, USER_APPOINTMENT_LIST_FOR_ADMIN, USER_APPOINTMENT_STATUS_UPDATE } from "../types";
  import strings from "translate/language";
  import { errorToast, successToast, unAuthorizedError } from "utils/httpClient";
import userAppointmentService from "../service/userAppointmentService"
  
  export const getCPAppointmentList = (item) => async (dispatch) => {
    try {
 
      const res = await userAppointmentService.getCPAppointmentList(item);

      if (res.data.status === 200) {
        dispatch({
          type: USER_APPOINTMENT_LIST,
          payload: res.data,
        });
      } else {
        dispatch({
          type: USER_APPOINTMENT_LIST,
          payload: [],
        });
      }
    } catch (e) {
      const { response = strings.initialError } = e;
      unAuthorizedError(response.data);
    }
  };

  export const getCPAppointmentListForAdmin = (item) => async (dispatch) => {
    try {
 
      const res = await userAppointmentService.getCPAppointmentListForAdmin(item);

      if (res.data.status === 200) {
        dispatch({
          type: USER_APPOINTMENT_LIST_FOR_ADMIN,
          payload: res.data,
        });
      } else {
        dispatch({
          type: USER_APPOINTMENT_LIST_FOR_ADMIN,
          payload: [],
        });
      }
    } catch (e) {
      const { response = strings.initialError } = e;
      unAuthorizedError(response.data);
    }
  };
  
  export const cpAppointmentStatusUpdate = (item) => async (dispatch) => {
    try {
      const res = await userAppointmentService.CPAppointmentstatusUpdate(item);
      if (res.data.status === 200) {
        dispatch({
          type: USER_APPOINTMENT_STATUS_UPDATE,
          payload: res.data,
        });
      } else {
        dispatch({
          type: USER_APPOINTMENT_STATUS_UPDATE,
          payload: [],
        });
      }
    } catch (e) {
      const { response = strings.initialError } = e;
      unAuthorizedError(response.data);
    }
  };

  export const createCpAppointment = (item) => async (dispatch) => {
    try {
      const res = await userAppointmentService.createCpAppointment(item);
      if (res.data.status === 200) {
        dispatch({
          type: CREATE_USER_APPOINTMENT,
          payload: res.data,
        });
      } else {
        dispatch({
          type: CREATE_USER_APPOINTMENT,
          payload: [],
        });
      }
    } catch (e) {
      const { response = strings.initialError } = e;
      unAuthorizedError(response.data);
    }
  };

  export const editCpAppointment = (item) => async (dispatch) => {
    try {
      const res = await userAppointmentService.editCpAppointment(item);
      if (res.data.status === 200) {
        dispatch({
          type: EDIT_USER_APPOINTMENT,
          payload: res.data,
        });
      } else {
        dispatch({
          type: EDIT_USER_APPOINTMENT,
          payload: [],
        });
      }
    } catch (e) {
      const { response = strings.initialError } = e;
      unAuthorizedError(response.data);
    }
  };